<div class="balance-container">
  <div class="balance-wrapper">
    <img class="token-icon" src="assets/icons/draftzy-icon.svg" alt="T" />
    <span class="body-14">Balance:</span>
    <span class="body-14 body-14--secondary bold">0</span>
  </div>
</div>
